import { EnumOf } from "../types/UtilTypes";

export const TimeUnit = {
	DAY: "day",
	WEEK: "week",
	MONTH: "month",
	YEAR: "year",
} as const;
export type TimeUnit = EnumOf<typeof TimeUnit>;
